import React from 'react';
import { useSelector } from 'react-redux';
import { hasPages } from 'app/stores/selectors';
import { Editor } from 'app/views/components/editor/Editor';
import { EmptyView } from 'app/views/components/empty';
export const ContentView = () => {
    const hasValidProject = useSelector(state => hasPages(state));
    if (hasValidProject) {
        return React.createElement(Editor, null);
    }
    return React.createElement(EmptyView, null);
};
